import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Home } from "./pages/Home";
import { Server } from "./pages/Server";
import { Assistant } from "./pages/Assistant";
import { Compliance } from "./pages/Compliance";
import { AiActAugust2026 } from "./pages/AiActAugust2026";
import { Standard } from "./pages/Standard";
import { Company } from "./pages/Company";
import { Contact } from "./pages/Contact";
import { LegalPlaceholder } from "./pages/LegalPlaceholder";
import { PageStub } from "./pages/PageStub";
import { VideoPlayer } from "./components/video";
import "./styles/marketing.css";
import "./App.css";

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/rannis-video" element={<VideoPlayer />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/server" element={<Server />} />
        <Route path="/assistant" element={<Assistant />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/ai-act-august-2026" element={<AiActAugust2026 />} />
        <Route path="/standard" element={<Standard />} />
        <Route path="/company" element={<Company />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/legal/privacy"
          element={<LegalPlaceholder title="Privacy policy" path="/legal/privacy" kind="terms" />}
        />
        <Route
          path="/legal/terms"
          element={<LegalPlaceholder title="Terms of service" path="/legal/terms" kind="terms" />}
        />
        <Route
          path="/legal/dpa"
          element={<LegalPlaceholder title="Data processing addendum" path="/legal/dpa" kind="clauses" />}
        />
        <Route
          path="*"
          element={
            <PageStub
              title="Page not found"
              description="That page doesn't exist."
              path="/"
            />
          }
        />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default App;
